import styled from '@emotion/styled';
import { Tooltip } from '@mui/material';

export const LayerItemContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  background: #f2f3f7;
  padding: 8px 0px;
  padding-left: 8px;
  gap: 8px;
  border-radius: 8px;
`;

export const ElementInfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const StyledTooltip = styled(Tooltip)`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const EllipsedText = styled.span`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 170px;
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: 12px;
  gap: 2px;
`;

export const StatusTooltip = styled(Tooltip)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LayerStatusIndicator = styled.div<{
  isFetched: boolean;
}>`
  width: 20px;
  height: 20px;
  border-radius: 9999px;
  background-color: ${({ isFetched }) => (!isFetched ? '#fee2e2' : 'transparent')};
  display: flex;
  align-items: center;
  justify-content: center;
`;
